export const REDIRECT_HOME_PAGE = "REDIRECT_HOME_PAGE";
export const REDIRECT_SPECIFIC_SHOPIFY_PAGE = "REDIRECT_SPECIFIC_SHOPIFY_PAGE";
export const REDIRECT_SPECIFIC_PRODUCT_PAGE = "REDIRECT_SPECIFIC_PRODUCT_PAGE";
export const REDIRECT_SPECIFIC_BLOG_POST = "REDIRECT_SPECIFIC_BLOG_POST";
export const REDIRECT_CUSTOM_URL = "REDIRECT_CUSTOM_URL";
export const DO_NOT_REDIRECT = "DO_NOT_REDIRECT";



